<!-- Encabezado / migas -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Inicio</a></li>
                <li>
                    <a routerLink="/configurar-administracion"
                        >Configuración Administración</a
                    >
                </li>
                <li>
                    <a routerLink="/ordenes-consulta">Órdenes de consulta</a>
                </li>
                <li>Listado por período</li>
            </ul>
            <h2>Órdenes por período</h2>
        </div>
    </div>
</div>

<!-- Ventana de contenido -->
<div
    class="andorra-apply-content ptb-70 animate__animated animate__fadeIn position-relative"
>
    <!-- Overlay de procesamiento -->
    <div class="processing-overlay" *ngIf="loading">
        <div class="processing-content">
            <mat-spinner [diameter]="56"></mat-spinner>
            <div class="processing-text">Procesando…</div>
        </div>
    </div>

    <div class="container">
        <div class="apply-form">
            <div class="af-header" style="align-items: flex-end">
                <div class="left">
                    <h3 class="m-0">Filtrar por fechas</h3>
                    <p class="muted m-0">Elegí un rango y buscá.</p>
                </div>

                <div
                    class="right d-flex"
                    style="gap: 8px; align-items: center; flex-wrap: wrap"
                >
                    <div>
                        <label class="muted">Desde</label>
                        <input
                            type="date"
                            [(ngModel)]="from"
                            class="form-control"
                            [disabled]="loading"
                        />
                    </div>
                    <div>
                        <label class="muted">Hasta</label>
                        <input
                            type="date"
                            [(ngModel)]="to"
                            class="form-control"
                            [disabled]="loading"
                        />
                    </div>

                    <button
                        mat-raised-button
                        class="btn-primary"
                        (click)="buscar()"
                        [disabled]="loading"
                    >
                        <ng-container *ngIf="!loading; else loadingLbl"
                            >Buscar</ng-container
                        >
                        <ng-template #loadingLbl>Buscando…</ng-template>
                    </button>

                    <button
                        mat-stroked-button
                        class="btn-secondary"
                        (click)="exportarExcel()"
                        [disabled]="loading || !rows?.length"
                    >
                        Exportar Excel
                    </button>

                    <a
                        class="btn btn-warning"
                        routerLink="/ordenes-consulta"
                        [class.disabled]="loading"
                        >Volver</a
                    >
                </div>
            </div>

            <div *ngIf="error" class="error-box mt-2">{{ error }}</div>

            <div class="mt-2" *ngIf="!error">
                <div
                    class="d-flex justify-content-between align-items-center mb-2"
                >
                    <div class="muted">
                        Total en el rango: <b>{{ total }}</b>
                    </div>
                </div>

                <div class="table-responsive">
                    <table
                        mat-table
                        [dataSource]="dataSource"
                        class="mat-elevation-z1 w-100"
                    >
                        <!-- Código -->
                        <ng-container matColumnDef="nro">
                            <th mat-header-cell *matHeaderCellDef>Código</th>
                            <td mat-cell *matCellDef="let r">
                                <a
                                    [routerLink]="[
                                        '/ordenes-consulta/detalle',
                                        r._id
                                    ]"
                                >
                                    {{ r.codigo || r.nro || r._id }}
                                </a>
                            </td>
                        </ng-container>

                        <!-- Fecha -->
                        <ng-container matColumnDef="createdAt">
                            <th mat-header-cell *matHeaderCellDef>Fecha</th>
                            <td mat-cell *matCellDef="let r">
                                {{ r.createdAt | date : "short" }}
                            </td>
                        </ng-container>

                        <!-- Estado -->
                        <ng-container matColumnDef="estado">
                            <th mat-header-cell *matHeaderCellDef>Estado</th>
                            <td mat-cell *matCellDef="let r">{{ r.estado }}</td>
                        </ng-container>

                        <!-- Tipo -->
                        <ng-container matColumnDef="tipo">
                            <th mat-header-cell *matHeaderCellDef>Tipo</th>
                            <td mat-cell *matCellDef="let r">{{ r.tipo }}</td>
                        </ng-container>

                        <!-- Sede -->
                        <ng-container matColumnDef="sede">
                            <th mat-header-cell *matHeaderCellDef>Sede</th>
                            <td mat-cell *matCellDef="let r">{{ r.sede }}</td>
                        </ng-container>

                        <!-- Usuario / Afiliado -->
                        <ng-container matColumnDef="afiliado">
                            <th mat-header-cell *matHeaderCellDef>
                                Usuario / Afiliado
                            </th>
                            <td mat-cell *matCellDef="let r">
                                {{ r.afiliado }}
                            </td>
                        </ng-container>

                        <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumns"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumns"
                        ></tr>
                    </table>
                </div>

                <mat-paginator
                    [length]="total"
                    [pageSize]="20"
                    [pageSizeOptions]="[20, 50, 100]"
                    showFirstLastButtons
                >
                </mat-paginator>

                <div *ngIf="!loading && rows.length === 0" class="empty mt-3">
                    No hay órdenes para el rango seleccionado.
                </div>
            </div>
        </div>
    </div>
</div>
